module.exports = __webpack_public_path__ + "img/logo-home.bf123299.png";